import { createLoaderImp } from '../../../components/ozmoit/common';
import { getRiskObservationsFormAction } from '../actions';

const {
  useLoader: useRiskObservationsFormLoader,
  LoaderProvider: StudentRiskObservationsFormLoader,
} = createLoaderImp({
  action: getRiskObservationsFormAction,
});



export { StudentRiskObservationsFormLoader, useRiskObservationsFormLoader };
